import { useDispatch, useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { restApi } from "@/store/rest_api";
import type { AppDispatch, RootState } from "@/store/store";
import type Notification from "@/model/interface/Notification";
import { prependNotificationInAllCaches } from "@/util/optimisticCache";
import { importRecordTags } from "@/util/importRuns";
import { useSocketSubscription } from "@/hooks/useSocketSubscription";
import { useSocketResync } from "@/hooks/useSocketResync";

export function useNotificationSocket() {
  const dispatch = useDispatch<AppDispatch>();
  const store = useStore<RootState>();
  const navigate = useNavigate();

  useSocketSubscription("/user/queue/notifications", (message) => {
    try {
      const notification: Notification = JSON.parse(message.body);
      prependNotificationInAllCaches(restApi, { dispatch, getState: store.getState }, notification);

      if (notification.type === "TRIAL_ENDING" && !message.replayed) {
        const link = notification.link;
        toast.warning(notification.title, {
          description: notification.message,
          action: link ? { label: "Choose a plan", onClick: () => navigate(link) } : undefined,
        });
      }
    } catch (error) {
      console.error("Failed to parse notification event", error);
    }
  });

  useSocketSubscription("/user/queue/data-changes", () => {
    dispatch(restApi.util.invalidateTags([...importRecordTags]));
  });

  useSocketResync((resync) => {
    if (!resync.fullRefresh) {
      dispatch(restApi.util.invalidateTags(["Notifications", ...importRecordTags]));
    }
  });
}
